//external
export const DjunoUrl = "https://djuno.io";
export const NpmPackageUrl = "https://www.npmjs.com/package/djuno-design";

export const GithubUrl = "https://github.com/Djuno-Ltd/djuno-design";
export const GithubCurrentBlob = "9ea6d2cfda342c308551c0c64f86679cd0d45a37";
export const GithubBlobLink = (section: string) =>
  GithubUrl + `/blob/${GithubCurrentBlob}/package/src/${section}`;
export const GithubTypesLink = GithubBlobLink("types/");

//internal
export const homePageUrl = "/";
export const installationPageUrl = "/docs/install";
export const ddpPageUrl = "/docs/ddp";

export const overviewPageUrl = "/docs/components";
export const panelLayoutsPageUrl = "/docs/components/panel-layouts";
export const typographyPageUrl = "/docs/components/typography";
export const buttonPageUrl = "/docs/components/button";
export const loadingPageUrl = "/docs/components/loading";
export const dividerPageUrl = "/docs/components/divider";
export const tooltipPageUrl = "/docs/components/tooltip";
export const dropdownPageUrl = "/docs/components/dropdown";
export const alertPageUrl = "/docs/components/alert";
export const stepsPageUrl = "/docs/components/steps";
export const skeletonPageUrl = "/docs/components/skeleton";
export const modalPageUrl = "/docs/components/modal";
export const popoverPageUrl = "/docs/components/popover";
export const emptyStatePageUrl = "/docs/components/empty-state";
export const accordionPageUrl = "/docs/components/accordion";
export const paginationPageUrl = "/docs/components/pagination";
export const sidebarPageUrl = "/docs/components/sidebar";
export const secureCopyPageUrl = "/docs/components/secure-copy";
export const formPageUrl = "/docs/components/form";
export const inputPageUrl = "/docs/components/form/input";
export const selectPageUrl = "/docs/components/form/select";
export const textareaPageUrl = "/docs/components/form/textarea";
export const switcherPageUrl = "/docs/components/form/switcher";
export const checkboxPageUrl = "/docs/components/form/checkbox";
export const tabsPageUrl = "/docs/components/tabs";
export const tabsWithUrlPageUrl = "/docs/components/tabs/tabs-support-url";
export const cardPageUrl = "/docs/components/card";
export const flexPageUrl = "/docs/components/flex";
export const simpleTablePageUrl = "/docs/components/simple-table";
export const jsonViewerPageUrl = "/docs/components/json-viewer";
export const themeChangersPageUrl = "/docs/components/theme-changers";
export const codeViewerPageUrl = "/docs/components/code-viewer";
export const TagPageUrl = "/docs/components/tag";

//hooks
export const hooksPageUrl = "/docs/hooks";
export const useDjunoDesignPageUrl = "/docs/hooks/use-djuno-design";
export const useShowPageUrl = "/docs/hooks/use-show";
export const useWindowOnClickPageUrl = "/docs/hooks/use-window-on-click";

//utilities
export const utilitiesPageUrl = "/docs/utilities";

//blogs
export const blogsPageUrl = "/docs/blogs";
export const copyableUrl = "/docs/blogs/copyable";
